'use strict';

angular.module('adelementAdminApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('roleMapping', {
                parent: 'entity',
                url: '/roleMappings',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'adelementAdminApp.roleMapping.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/roleMapping/roleMappings.html',
                        controller: 'RoleMappingController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('roleMapping');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('roleMapping.detail', {
                parent: 'entity',
                url: '/roleMapping/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'adelementAdminApp.roleMapping.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/roleMapping/roleMapping-detail.html',
                        controller: 'RoleMappingDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('roleMapping');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'RoleMapping', function($stateParams, RoleMapping) {
                        return RoleMapping.get({id : $stateParams.id});
                    }]
                }
            })
            .state('roleMapping.new', {
                parent: 'roleMapping',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/roleMapping/roleMapping-dialog.html',
                        controller: 'RoleMappingDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    role: null,
                                    uiRole: null,
                                    accessLevel: null,
                                    accessRight: null,
                                    type: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('roleMapping', null, { reload: true });
                    }, function() {
                        $state.go('roleMapping');
                    })
                }]
            })
            .state('roleMapping.edit', {
                parent: 'roleMapping',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/roleMapping/roleMapping-dialog.html',
                        controller: 'RoleMappingDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['RoleMapping', function(RoleMapping) {
                                return RoleMapping.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('roleMapping', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            })
            .state('roleMapping.delete', {
                parent: 'roleMapping',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/roleMapping/roleMapping-delete-dialog.html',
                        controller: 'RoleMappingDeleteController',
                        size: 'md',
                        resolve: {
                            entity: ['RoleMapping', function(RoleMapping) {
                                return RoleMapping.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('roleMapping', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    });
